<template>
  <div class="UsuariosListado">
    <md-table v-model="filtro_usuarios" md-card md-fixed-header>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Usuarios registrados</h1>
        </div>
        <md-field md-clearable class="md-toolbar-section-end">
          <md-input placeholder="Buscar usuario..." v-model="buscar" @input="buscarEnLaTabla" />
        </md-field>
      </md-table-toolbar>
      <md-table-empty-state md-label="No se encontraron usuarios" :md-description="``"></md-table-empty-state>
      <md-table-row slot="md-table-row" slot-scope="{ item }" class="md-accent" md-selectable="single">
        <md-table-cell md-label="Nombre">{{ item.nombre }} </md-table-cell>
        <md-table-cell md-label="Correo">{{ item.correo }}</md-table-cell>
        <md-table-cell md-label="Institución">{{ item.institucion}}</md-table-cell>
        <md-table-cell md-label="Estatus">{{item.estatus.toUpperCase()}}</md-table-cell>
        <md-table-cell md-label="Vig. susc.">{{vigenciaCuenta(item.vigencia)}}</md-table-cell>
        <md-table-cell md-label="Acciones">
          <md-button class="md-icon-button" @click.native="editarEstatusUsuario(item)">
            <md-icon>edit</md-icon>
            <md-tooltip md-direction="left">Editar estatus</md-tooltip>
          </md-button>
          <md-button class="md-icon-button" @click.native="irDetalleUsuario(item.usuario)">
            <md-icon>more_vert</md-icon>
            <md-tooltip md-direction="left">Información del usuario</md-tooltip>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-dialog :md-active.sync="mostrar_modal_editar_estatus_usuario">
      <md-dialog-title>Estatus del usuario</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout-item">
          <md-field>
            <label for="estatus">Estatus</label>
            <md-select v-model="usuario.estatus" name="estatus" id="estatus">
              <md-option value="activo">Activo</md-option>
              <md-option value="inactivo">Inactivo</md-option>
              <md-option value="validacion">Validacion</md-option>
              <md-option value="recuperacion">Recuperacion</md-option>
            </md-select>
          </md-field>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="mostrar_modal_editar_estatus_usuario = false">Cerrar</md-button>
        <md-button class="md-raised md-accent" @click.native="actualizarEstatusUsuario()">Guardar cambios</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import moment from "moment";
const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarNombre = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.nombre).includes(toLower(term)));
  }
  return items;
};

export default {
  name: "UsuariosListado",
  props: ["sb"],
  methods: {
    buscarEnLaTabla() {
      this.filtro_usuarios = buscarNombre(this.usuarios, this.buscar);
    },
    obtenerUsuarios() {
      this.$http
        .post("usuarios", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "usuarios" in response.body) {
              this.usuarios = response.body.usuarios;
              this.filtro_usuarios = response.body.usuarios;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para obtener los tipos de pruebas";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    editarEstatusUsuario(u) {
      if (u) {
        this.usuario.usuario = u.usuario;
        this.usuario.estatus = u.estatus;
        this.mostrar_modal_editar_estatus_usuario = true;
      }
    },
    vigenciaCuenta(fecha) {
      if (fecha) {
        if (moment() > moment(fecha)) {
          return "Vencida";
        } else {
          return fecha;
        }
      } else {
        return "SIN SUSCRIPCIÓN";
      }
    },
    actualizarEstatusUsuario() {
      this.$http
        .post("usuarios/actualizarestatus", {
          token: this.$session.get("token"),
          data: this.usuario
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.obtenerUsuarios();
              this.mostrar_modal_editar_estatus_usuario = false;
              this.$parent.sb.texto = response.body.msg;
            } else {
              this.$parent.sb.texto = response.body.error;
            }
            this.$parent.sb.mostrar = true;
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para obtener los tipos de pruebas";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    irDetalleUsuario(a) {
      this.$router.push({
        name: "UsuariosDetalleCuenta",
        params: { cuenta: a }
      });
    }
  },
  data() {
    return {
      buscar: null,
      mostrar_modal_editar_estatus_usuario: false,
      texto_a_buscar: null,
      usuarios: [],
      usuario: {
        usuario: null,
        estatus: null
      },
      filtro_usuarios: []
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerUsuarios();
  }
};
</script>